export const text = {
  'es': {
    'job': 'Bolsa de trabajo',
    'foundation': 'Fundación Sanfer',
    'lang': 'English'
  },
  'en': {
    'job': 'Job board',
    'foundation': 'Sanfer Foundation',
    'lang': 'Español'
  }
}

const esLangSection = {
  'us': {
    'title': 'Nosotros',
    'url': '/nosotros',
    'subItems': [
      {
        'title': 'Sobre nosotros',
        'url': '/sobre-nosotros',
      },
      {
        'title': 'Historia',
        'url': '/historia',
      },
      {
        'title': 'Operaciones',
        'url': '/produccion-y-operaciones',
      },
      {
        'title': 'Sanfer global',
        'url': '/sanfer-global',
      },
    ]
  },
  'products': {
    'title': 'Áreas de negocio',
    'url': '/productos',
    'subItems': [
      {
        'title': 'Productos de libre acceso',
        'url': '/productos/libre-venta',
      },
      {
        'title': 'Medicamentos de prescripción',
        'url': '/productos/prescripcion',
      },
      {
        'title': 'Salud animal',
        'url': '/productos/salud-animal',
      }
    ]
  },
  'healthcareProfessionals': {
    'title': 'Profesionales de la salud',
    'url': '/profesionales-de-la-salud',
  },
  'pharmacovigilance': {
    'title': 'Farmacovigilancia',
    'url': '/farmacovigilancia'
  },
  'contact': {
    'title': 'Contacto',
    'url': '/contacto'
  },
}

const enLangSection = {
  'us': {
    'title': 'Us',
    'url': '/nosotros',
    'subItems': [
      {
        'title': 'About us',
        'url': '/sobre-nosotros',
      },
      {
        'title': 'Our history',
        'url': '/historia',
      },
      {
        'title': 'Operations',
        'url': '/produccion-y-operaciones',
      },
      {
        'title': 'Sanfer global',
        'url': '/sanfer-global',
      },
    ]
  },
  'products': {
    'title': 'Products',
    'url': '/productos',
    'subItems': [
      {
        'title': 'Products',
        'url': '/productos/libre-venta',
      },
      {
        'title': 'Therapeutic areas',
        'url': '/areas-terapeuticas',
      },
      {
        'title': 'Animal health',
        'url': '/salud-animal',
      }
    ]
  },
  'healthcareProfessionals': {
    'title': 'Healthcare professionals',
    'url': '/profesionales-de-la-salud',
  },
  'pharmacovigilance': {
    'title': 'Pharmacovigilance',
    'url': '/farmacovigilancia'
  },
  'contact': {
    'title': 'Contact',
    'url': '/contacto'
  },
}

export const sections = {
  es: esLangSection,
  en: enLangSection
}